
import {
  DxColumn,
  DxDataGrid,
  DxDataGridTypes,
  DxExport,
  DxItem,
  DxPaging,
  DxScrolling,
  DxToolbar as DxToolbarGrid,
} from "devextreme-vue/data-grid";

import { DxLoadPanel } from "devextreme-vue/load-panel";

import DxButton from "devextreme-vue/button";
import DxToolbar, { DxItem as DxItemToolBar } from "devextreme-vue/toolbar";
import { ValueChangedEvent } from "devextreme/ui/check_box";
import { ValueChangedEvent as ValueChangedEventDateBox } from "devextreme/ui/date_box";
import { Workbook } from "exceljs";
import { Component, VModel, Vue, Watch } from "vue-property-decorator";
// Our demo infrastructure requires us to use 'file-saver-es'.
// We recommend that you use the official 'file-saver' package in your applications.
import { exportDataGrid } from "devextreme/excel_exporter";
import saveAs from "file-saver";

import { apiUrls } from "@/environment/environment";
import notify from "devextreme/ui/notify";
import IndexationController from "../../shared/services/controllers/indexation/indexationController";
import { CalculatedIndexation } from "../../shared/types/Indexation";

@Component({
  components: {
    DxLoadPanel,
    DxColumn,
    DxDataGrid,
    DxItem,
    DxPaging,
    DxScrolling,
    DxToolbarGrid,
    DxExport,
    DxButton,
    DxToolbar,
    DxItemToolBar,
  },
})
export default class IndexationSimulationGrille extends Vue {
  @VModel() selectedRowKeys!: number[];

  @Watch("selectedRowKeys")
  onSelectedRowKeysChanged(): void {
    if (this.customers.length > 0) {
      this.customers = [];
    }
  }

  customers: CalculatedIndexation[] = [];
  private controller: IndexationController;

  constructor() {
    super();
    this.controller = new IndexationController(apiUrls.indexation);
  }

  onlyUpdate = true;
  dateUpdate = new Date();

  simulateButtonOptions = {
    text: "Simuler",
    onClick: this.postSimulationCalcul,
  };
  appliquerButtonOptions = {
    text: "Appliquer",
    onClick: this.postFinalCalcul,
  };

  onCheckBoxValueChanged(e: ValueChangedEvent) {
    this.customers = [];
    this.onlyUpdate = e.value;
  }

  onDateBoxValueChanged(e: ValueChangedEventDateBox) {
    this.customers = [];
    this.dateUpdate = e.value;
  }

  /**
   * Appel au calcul avec simulation
   */
  async postSimulationCalcul() {
    this.customers = [];
    const datagrid = this.$refs.dxDataGrid as DxDataGrid;
    datagrid?.instance?.beginCustomLoading("Chargement...");

    await this.controller.indexationStore
      .postSimulationCalcul(this.selectedRowKeys, this.dateUpdate, this.onlyUpdate)
      .then((result: { data: CalculatedIndexation[]; itemsCount: number }) => {
        this.customers = result.data;
      })
      .finally(() => {
        datagrid?.instance?.endCustomLoading();
      });
  }
  finalCalculLoadPanel = false;
  async postFinalCalcul() {
    this.finalCalculLoadPanel = true;
    await this.controller.indexationStore
      .postFinalCalcul(this.selectedRowKeys, this.dateUpdate, this.onlyUpdate)
      .then(() => {
        this.finalCalculLoadPanel = false;
        notify(
          {
            message: "Mise à jour des nouveaux taux correctement effectuée",
            width: 400,
            type: "success",
            displayTime: 3500,
            animation: {
              show: {
                type: "fade",
                duration: 400,
                from: 0,
                to: 1,
              },
              hide: { type: "fade", duration: 40, to: 0 },
            },
          },
          { position: "top right", direction: "down-push" }
        );
      })
      .catch((error) => {
        notify(
          {
            message: error,
            width: 400,
            type: "error",
            displayTime: 3500,
            animation: {
              show: {
                type: "fade",
                duration: 400,
                from: 0,
                to: 1,
              },
              hide: { type: "fade", duration: 40, to: 0 },
            },
          },
          { position: "top right", direction: "down-push" }
        );
        this.finalCalculLoadPanel = false;
      });
  }

  onExporting = (e: DxDataGridTypes.ExportingEvent) => {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet("CalculIndexationTaux");

    exportDataGrid({
      component: e.component,
      worksheet,
      autoFilterEnabled: true,
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(new Blob([buffer], { type: "application/octet-stream" }), `SimulationIndexation${new Date()}.xlsx`);
      });
    });

    e.cancel = true;
  };
}
